
























import { Component, Vue } from 'vue-property-decorator'
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import RoleFilterOptions from '@/types/RoleFilterOptions'

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class RoleFilter extends Vue {
    roleStatuses: RoleStatus[] = [
        { value: null, text: 'roleStatus.selectRoleStatus' },
        { value: true, text: 'roleStatus.yes' },
        { value: false, text: 'roleStatus.no' }
    ]

    filter: RoleFilterOptions = {
        sequenceOrName: null,
        isActive: true
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.sequenceOrName = null;
            this.filter.isActive = true;
        }
        this.$emit('filter-list', this.filter);
    }
}

interface RoleStatus {
    value: boolean | null;
    text: string;
}
